/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Text2DAlignment, Text2DVerticalAlignment, Text2D, Orientation } from '@sick-davinci/glow';
import { CrownCapNames } from './CrownCapNames';
import { Color, Quaternion, Vector3 } from 'three';
const hAlignList = {
    RIGHT: Text2DAlignment.RIGHT,
    LEFT: Text2DAlignment.LEFT,
    CENTERH: Text2DAlignment.CENTER,
    JUSTIFY: Text2DAlignment.BLOCK,
};
const vAlignList = {
    TOP: Text2DVerticalAlignment.TOP,
    BOTTOM: Text2DVerticalAlignment.BOTTOM,
    CENTERV: Text2DVerticalAlignment.CENTER,
};
const _1_255 = 1 / 255;
/**
 * Capability to add Text
 */
export class CrownTextCap {
    constructor(fontMap) {
        this._fontMap = fontMap;
    }
    getName() {
        return CrownCapNames.CROWNTEXT;
    }
    doClassToCapabilityMapping(map) {
        map.set(CrownTextCap.className, CrownCapNames.CROWNTEXT);
        map.set(CrownTextCap.decoClassName, CrownCapNames.CROWNTEXT);
    }
    call(capData, sceneIn) {
        const { payload } = capData;
        if (payload.Type === CrownTextCap.className) {
            const deco = !!payload.Decorations && payload.Decorations.length === 1 ? payload.Decorations[0].data : undefined;
            payload.Iconics.forEach((t) => {
                const font = this._getFont(deco.FontFamily);
                if (font != null) {
                    font.setStyle({
                        color: new Color(deco.Color.R, deco.Color.G, deco.Color.B).multiplyScalar(_1_255),
                        asBillboard: !!deco.BillboardActive,
                        opacity: deco.Color.A / 255,
                    });
                    const textRenderer = new Text2D(font, !!deco.FlipY);
                    applyDecoration(capData, textRenderer, deco);
                    textRenderer.setText(t.data.value);
                    textRenderer.userData.imaginary = true;
                    Orientation.set(textRenderer, capData);
                    textRenderer.name = capData.name;
                    sceneIn.addToParent(capData.parent || '', textRenderer);
                    sceneIn.setTag(capData.tag, textRenderer);
                }
                else {
                    console.warn('Font "' + deco.FontFamily + '" not found.'); // tslint:disable-line: no-console
                }
            });
            return true;
        }
        return false;
    }
    update(capData, sceneIn) {
        const { payload: { Decoration, IconicId } } = capData;
        if (Decoration.class === CrownTextCap.decoClassName) {
            const txt = sceneIn.getObjectByName(IconicId);
            if (txt != null) {
                const deco = Decoration.data;
                const font = this._getFont(deco.FontFamily);
                if (font != null) {
                    font.setStyle({
                        color: new Color(deco.Color.R, deco.Color.G, deco.Color.B).multiplyScalar(1 / 255),
                        asBillboard: deco.BillboardActive,
                        opacity: deco.Color.A / 255,
                    });
                    txt.enableFlipY(!!deco.FlipY);
                    txt.setFont(font);
                    applyDecoration(capData, txt, deco);
                    return true;
                }
            }
        }
        return false;
    }
    _getFont(fontName) {
        // tslint:disable-next-line:no-any
        return this._fontMap[fontName];
    }
}
CrownTextCap.className = 'TEXT';
CrownTextCap.decoClassName = 'View.TextDecoration';
function applyDecoration(capData, textRenderer, deco) {
    if (!!deco.Bounds) {
        const tbRight = deco.Bounds.Width / 2;
        const tbLeft = -tbRight;
        const tbTop = deco.Bounds.Height / 2;
        const tbBottom = -tbTop;
        textRenderer.setTextBox({ top: tbTop, left: tbLeft, bottom: tbBottom, right: tbRight });
        textRenderer.enableAutoWrapping(true);
    }
    textRenderer.setLineHeight(deco.FontSize);
    textRenderer.setLineSpacing(deco.LineSpacing);
    textRenderer.setAlignment(hAlignList[deco.HorizontalAlignment]);
    textRenderer.setVerticalAlignment(vAlignList[deco.VerticalAlignment]);
    const axis = new Vector3(0, 0, -1); // default axis
    if (!!deco.RotationAxis) {
        axis.fromArray([deco.RotationAxis.x, deco.RotationAxis.y, deco.RotationAxis.z]).normalize();
    }
    const q = new Quaternion();
    q.setFromAxisAngle(axis, deco.Rotation);
    Orientation.prepend(capData, {
        quaternion: q.toArray(),
        position: [deco.Position.x, deco.Position.y, deco.Position.z],
    });
}
//# sourceMappingURL=CrownTextCap.js.map